import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const ArrowUpDownIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M7.47081 2.97674C7.47081 2.70274 7.6938 2.48062 7.96886 2.48062C8.24393 2.48062 8.46692 2.70274 8.46692 2.97674L8.46692 12.8992C8.46692 13.1732 8.24393 13.3953 7.96886 13.3953C7.6938 13.3953 7.47081 13.1732 7.47081 12.8992L7.47081 2.97674Z"
      fill="currentColor"
    />
    <path
      d="M4.62841 5.31202C4.4339 5.11827 4.4339 4.80422 4.62841 4.61047L7.61673 1.63372C7.81123 1.43997 8.12651 1.43997 8.32101 1.63372L11.3093 4.61047C11.5038 4.80422 11.5038 5.11827 11.3093 5.31202C11.1148 5.50577 10.7996 5.50577 10.6051 5.31202L7.96887 2.68605L5.33269 5.31202C5.13818 5.50577 4.82291 5.50577 4.62841 5.31202Z"
      fill="currentColor"
    />
    <path
      d="M11.3093 10.564C11.5038 10.7577 11.5038 11.0718 11.3093 11.2655L8.32101 14.2422C8.22761 14.3353 8.10096 14.3876 7.96887 14.3876C7.83678 14.3876 7.71013 14.3353 7.61673 14.2422L4.6284 11.2655C4.4339 11.0718 4.4339 10.7577 4.6284 10.564C4.82291 10.3702 5.13818 10.3702 5.33268 10.564L7.96887 13.1899L10.6051 10.564C10.7996 10.3702 11.1148 10.3702 11.3093 10.564Z"
      fill="currentColor"
    />
  </svg>
);
